import { TranslationKey, translationKey } from 'intl/types/translationKey';

/**
 * AUTO-GENERATED — do not edit manually.
 * Run `yarn generate:translation-keys` after changing messages.en.json.
 */
export const AnalyticsTranslationKeys = {
  inspectionResultChart: translationKey('average_inspection_result_chart'),
  resolutionTimeChart: translationKey('average_resolution_time_chart'),
  resolutionTimeChartOverallSeries: translationKey('average_resolution_time_chart_overall_series'),
  resolutionTimeChartSegmentSeries: translationKey('average_resolution_time_chart_segment_series'),
  resolutionTimeChartSegmentValidationFromSmallerThanTo: translationKey('average_resolution_time_chart_segment_validation_from_smaller_than_to'),
  resolutionTimeChartSegmentValidationFromToFilled: translationKey('average_resolution_time_chart_segment_validation_from_to_filled'),
  cardSubtitleDetectedResolved: translationKey('chart_card_subtitle_detected_resolved'),
  cardSubtitleEnvironmentalAspect: translationKey('chart_card_subtitle_environmental_aspect'),
  cardSubtitleFailedInspectionFactor: translationKey('chart_card_subtitle_failed_inspection_factor'),
  cardSubtitleHazardType: translationKey('chart_card_subtitle_hazard_type'),
  cardSubtitleImpact: translationKey('chart_card_subtitle_impact'),
  cardSubtitleInspectionCount: translationKey('chart_card_subtitle_inspection_count'),
  cardSubtitleInspectionEvolution: translationKey('chart_card_subtitle_inspection_evolution'),
  cardSubtitleInspectionResult: translationKey('chart_card_subtitle_inspection_result'),
  cardSubtitleInspectionTriplet: translationKey('chart_card_subtitle_inspection_triplet'),
  cardSubtitleInspectionsByTemplate: translationKey('chart_card_subtitle_inspections_by_template'),
  cardSubtitleOriginator: translationKey('chart_card_subtitle_originator'),
  cardSubtitleResolutionTime: translationKey('chart_card_subtitle_resolution_time'),
  cardSubtitleRootCause: translationKey('chart_card_subtitle_root_cause'),
  cardSubtitleWorkType: translationKey('chart_card_subtitle_work_type'),
  categoricalDistributionsSection: translationKey('chart_categorical_distributions_section'),
  customFilters: translationKey('chart_custom_filters'),
  customFiltersRestore: translationKey('chart_custom_filters_restore'),
  customFiltersTooltip: translationKey('chart_custom_filters_tooltip'),
  donutCenterTotal: translationKey('chart_donut_center_total'),
  exportColumnCategory: translationKey('chart_export_column_category'),
  exportColumnValue: translationKey('chart_export_column_value'),
  exportCsv: translationKey('chart_export_csv'),
  exportError: translationKey('chart_export_error'),
  exportGeneratedAt: translationKey('chart_export_generated_at'),
  exportPdf: translationKey('chart_export_pdf'),
  exportPng: translationKey('chart_export_png'),
  exportXlsx: translationKey('chart_export_xlsx'),
  inspectionEvolutionCompleted: translationKey('chart_inspection_evolution_completed'),
  inspectionsSection: translationKey('chart_inspections_section'),
  issuesSection: translationKey('chart_issues_section'),
  lastUpdate: translationKey('chart_last_update'),
  legendOther: translationKey('chart_legend_other'),
  noData: translationKey('chart_no_data'),
  noDataHelperLine1: translationKey('chart_no_data_helper_line_1'),
  noDataHelperLine2: translationKey('chart_no_data_helper_line_2'),
  sectionFiltersLabel: translationKey('chart_section_filters_label'),
  sectionFiltersMixed: translationKey('chart_section_filters_mixed'),
  settingsDataLabels: translationKey('chart_settings_data_labels'),
  settingsTab: translationKey('chart_settings_tab'),
  type: translationKey('chart_type'),
  typeArea: translationKey('chart_type_area'),
  typeBar: translationKey('chart_type_bar'),
  typeDonut: translationKey('chart_type_donut'),
  typeLine: translationKey('chart_type_line'),
  typeRadialBar: translationKey('chart_type_radialBar'),
  viewDetails: translationKey('chart_view_details'),
  yAxis: translationKey('chart_y_axis'),
  yAxisDays: translationKey('chart_y_axis_days'),
  yAxisPercentage: translationKey('chart_y_axis_percentage'),
  inspectionsByTemplateChart: translationKey('completed_inspections_by_template_chart'),
  inspectionsChart: translationKey('completed_inspections_chart'),
  dateRange: translationKey('data_scope_date_range'),
  interval: translationKey('data_scope_interval'),
  originators: translationKey('data_scope_originators'),
  sites: translationKey('data_scope_sites'),
  tab: translationKey('data_scope_tab'),
  intervalDay: translationKey('date_range_interval_day'),
  intervalMonth: translationKey('date_range_interval_month'),
  intervalTooLargeError: translationKey('date_range_interval_too_large_error'),
  intervalWeek: translationKey('date_range_interval_week'),
  intervalYear: translationKey('date_range_interval_year'),
  resolvedChart: translationKey('detected_resolved_chart'),
  aspectChart: translationKey('environmental_aspect_chart'),
  effectChart: translationKey('hs_effect_chart'),
  effectChartDangerousConditionsActions: translationKey('hs_effect_chart_dangerous_conditions_actions'),
  chart: translationKey('impact_chart'),
  scoreChart: translationKey('originator_score_chart'),
  scoreChartBudgetExposure: translationKey('originator_score_chart_budget_exposure'),
  scoreChartCalculationInfo: translationKey('originator_score_chart_calculation_info'),
  scoreChartEmployeeExclusion: translationKey('originator_score_chart_employee_exclusion'),
  scoreChartFilterInfo: translationKey('originator_score_chart_filter_info'),
  scoreChartReactionTime: translationKey('originator_score_chart_reaction_time'),
  scoreChartRiskExposure: translationKey('originator_score_chart_risk_exposure'),
  scoreChartTimeExposure: translationKey('originator_score_chart_time_exposure'),
  scoreChartWorksImpact: translationKey('originator_score_chart_works_impact'),
  scoreLegendAlarmingDangerous: translationKey('originator_score_legend_alarming_dangerous'),
  scoreLegendControllableCompliant: translationKey('originator_score_legend_controllable_compliant'),
  scoreLegendNeutralSafe: translationKey('originator_score_legend_neutral_safe'),
  issueType: translationKey('presented_issue_type'),
  segmentsDays: translationKey('presented_segments_days'),
  tab2: translationKey('presented_tab'),
  rootCauseChart: translationKey('root_cause_chart'),
  workTypeChart: translationKey('work_type_chart'),
} as const satisfies Record<string, TranslationKey>;
